<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading" class="w-full min-w-0 max-w-full [container-type:inline-size]">
    <div class="flex gap-3 mb-4 mr-5 ml-0">
        <p class="font-semibold text-[#424242] mb-4 mr-5 ml-0 dark:text-[#FFFFFF] cursor-pointer">Manage
            Officers</p>
    </div>

    <div class="w-full bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg">
        <div class="px-10 py-7 min-w-0 [@container(max-width:640px)]:px-4">
            <div class="flex flex-row flex-wrap items-center justify-between gap-4 w-full [@container(min-width:761px)]:flex-nowrap">
                <div class="flex flex-row gap-4 flex-shrink-0 [@container(max-width:480px)]:flex-wrap [@container(max-width:480px)]:shrink">
                    <button
                        class="w-28  bg-[#415CFF] text-[#FFFFFF] dark:text-white rounded-lg shadow-lg px-4 py-2 whitespace-nowrap"
                        (click)="navigate('/distribution-officers/create-distribution-officer')">
                        Add Officer
                    </button>

                    <span *ngIf="logingRole === 'Distribution Centre Manager'">
                        <button
                            class="bg-[#415CFF] whitespace-nowrap text-white text-center rounded-lg shadow-lg px-4 py-2 w-32"
                            (click)="navigate('/distribution-officers/claim-officer')">
                            Claim Officer
                        </button>
                    </span>
                </div>
                <div class="flex flex-row items-center justify-end gap-5 flex-1 min-w-0 [@container(max-width:760px)]:basis-full [@container(max-width:760px)]:flex-wrap [@container(max-width:1000px)]:gap-3 [@container(max-width:640px)]:justify-start">

                    <div class="ml-1 relative w-44 flex-shrink-0 [@container(max-width:1000px)]:w-40 [@container(max-width:640px)]:ml-0 [@container(max-width:640px)]:!w-full custom-role-dropdown-container">
                        <!-- Hidden native select -->
                        <select [(ngModel)]="selectRole" class="hidden" (change)="applyRoleFilters()">
                            <option value="Distribution Centre Manager">Distribution Centre Manager</option>
                            <option value="Distribution Officer">Distribution Officer</option>
                            <option value="Distribution Officer">Driver</option>

                        </select>

                        <!-- Custom dropdown trigger -->
                        <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                            (click)="toggleRoleDropdown()">
                            <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer">
                                <span>{{ selectRole || 'Role' }}</span>
                                <div class="flex items-center">
                                    <i *ngIf="selectRole" (click)="clearRoleFilter($event)"
                                        class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>
                                    <i *ngIf="isRoleDropdownOpen || !selectRole"
                                        class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                        [class.fa-angle-down]="!isRoleDropdownOpen"
                                        [class.fa-angle-up]="isRoleDropdownOpen"></i>
                                </div>
                            </div>
                        </div>

                        <!-- Custom dropdown options -->
                        <div *ngIf="isRoleDropdownOpen"
                            class="absolute z-10 overflow-hidden w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282]">
                            <div class="">
                                <div *ngFor="let option of roleDropdownOptions; let i = index"
                                    (click)="selectRoleOption(option)"
                                    class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center"
                                    [ngClass]="{
                                    'rounded-t-xl': i === 0,
                                    'rounded-b-xl': i === roleDropdownOptions.length - 1
                                  }">
                                    <span class="flex-grow">{{ option }}</span>
                                    <i
                                        class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                                </div>
                            </div>
                        </div>
                    </div>


                    <!-- <div *ngIf="isDropdownOpen" class="dropdown-backdrop" (click)="isDropdownOpen = false"></div> -->
                    <div class="relative w-28 flex-shrink-0 [@container(max-width:640px)]:!w-full custom-status-dropdown-container">
                        <!-- Hidden native select -->
                        <select [(ngModel)]="selectStatus" class="hidden" (change)="applyStatusFilters()">
                            <option class="hover:bg-gray-300 dark:hover:bg-gray-300" value=""></option>
                            <option class="hover:bg-gray-300 dark:hover:bg-gray-300" value="Approved">Approved</option>
                            <option class="hover:bg-gray-300 dark:hover:bg-gray-300" value="Not Approved">Not Approved
                            </option>
                            <option class="hover:bg-gray-300 dark:hover:bg-gray-300" value="Rejected">Rejected</option>
                        </select>

                        <!-- Custom dropdown trigger -->
                        <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                            (click)="toggleStatusDropdown()">
                            <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer ">
                                <span>{{ selectStatus || 'Status' }}</span>
                                <div class="flex items-center ">
                                    <i *ngIf="selectStatus" (click)="clearStatusFilter($event)"
                                        class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>
                                    <i *ngIf="isStatusDropdownOpen || !selectStatus"
                                        class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                        [class.fa-angle-down]="!isStatusDropdownOpen"
                                        [class.fa-angle-up]="isStatusDropdownOpen"></i>
                                </div>
                            </div>
                        </div>

                        <!-- Custom dropdown options -->
                        <div *ngIf="isStatusDropdownOpen"
                            class="absolute z-10 w-full overflow-hidden mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282]">
                            <div class="">
                                <div *ngFor="let option of statusDropdownOptions; let i = index"
                                    (click)="selectStatusOption(option)"
                                    class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center"
                                    [ngClass]="{
                                    'rounded-t-xl': i === 0,
                                    'rounded-b-xl': i === statusDropdownOptions.length - 1
                                  }">
                                    <span class="flex-grow">{{ option }}</span>
                                    <i
                                        class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="relative w-52 flex-shrink-0 [@container(max-width:1000px)]:w-40 [@container(max-width:640px)]:!w-full custom-center-dropdown-container"
                        *ngIf="logingRole === 'Distribution Centre Head'">
                        <app-searchable-dropdown [items]="centerDropdownItems" placeholder="Centre"
                            searchPlaceholder="Search centre..." [(ngModel)]="selectCenters"
                            (selectionChange)="onCenterSelectionChange($event)" [clearable]="true" [showSelected]="true"
                            [disabled]="false" [placeholderClass]="'text-[#5C5C5C] dark:text-textDark'"
                            class="w-full"></app-searchable-dropdown>
                    </div>

                    <div
                        class="flex items-center text-[#95A1AC] text-normal rounded-full px-4 py-2 flex-1 min-w-0 max-w-xs [@container(max-width:1000px)]:[&_button]:shrink-0 [@container(max-width:640px)]:basis-full [@container(max-width:640px)]:min-w-0 [@container(max-width:640px)]:max-w-none bg-[#F1F1F1] dark:bg-[#292929]">
                        <input type="text" placeholder="Search by EMP ID, First / Last name,NIC"
                            title="Search by EMP ID, First Name, Last Name or NIC"
                            [(ngModel)]="searchText" (keyup.enter)="onSearch()" (keyup.esc)="offSearch()"
                            class="bg-transparent outline-none w-full min-w-0 text-textLight dark:text-textDark" />
                        <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                            (click)="onSearch()">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                            </svg>
                        </button>
                        <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                            (click)="offSearch()">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                </div>

            </div>

            <div>
                <div *ngIf="!hasData"
                    class="flex flex-col items-center w-full h-screen px-10 py-7 bg-tileLight dark:bg-[#363636] dark:text-textDark mt-6">
                    <p class="text-[#494949] my-6 dark:text-textDark">--No Data Availabale--</p>
                    <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20 dark:text-textDark" />
                </div>

                <div *ngIf="hasData"
                    class="isolate mt-5 overflow-auto max-h-[max(410px,calc(100vh-380px))] border-gray-100 border-[2px] rounded-lg dark:border-[#202021]">
                    <table class="w-full min-w-max divide-y-2">
                        <thead
                            class="sticky top-0 z-20 bg-white text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021] cursor-default">
                            <tr>
                                <th class="sticky left-0 bg-white dark:bg-[#0F0F0F] w-14 min-w-14 px-2 py-3 text-left text-sm font-medium">No</th>
                                <th class="sticky left-14 bg-white dark:bg-[#0F0F0F] w-32 min-w-32 px-3 py-3 text-left text-sm font-medium">EMP ID</th>
                                <th class="px-3 py-3 text-left text-sm font-medium">First Name</th>
                                <th class="px-3 py-3 text-left text-sm font-medium">Last Name</th>
                                <th class="px-3 py-3 text-left text-sm font-medium"
                                    *ngIf="logingRole ==='Distribution Centre Head'">
                                    Centre</th>
                                <th class="px-3 py-3 text-left text-sm font-medium ">Role</th>
                                <th class="px-3 py-3 text-center text-sm font-medium ">Status</th>
                                <th class="px-3 py-3 text-center text-sm font-medium">Mobile Number-1</th>
                                <th class="px-3 py-3 text-center text-sm font-medium">NIC</th>
                                <th class="px-3 py-3 text-center text-sm font-medium"></th>
                            </tr>
                        </thead>
                        <tbody class="bg-white text-[#000000] dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                            <tr *ngFor="let item of OfficerArr | paginate
                : {
                    itemsPerPage: itemsPerPage,
                    currentPage: page,
                    totalItems: totalItems
                  };  let i = index">
                                <td class="sticky left-0 z-10 bg-white dark:bg-[#1D1D1F] px-2 py-4 text-sm text-gray-900 dark:text-gray-300">
                                    {{ (((page - 1) * itemsPerPage) + i + 1) < 10 ? '0' + (((page - 1) * itemsPerPage) +
                                        i + 1) : (((page - 1) * itemsPerPage) + i + 1) }} </td>
                                <td class="sticky left-14 z-10 bg-white dark:bg-[#1D1D1F] px-3 py-4 text-sm text-gray-900 dark:text-gray-300 break-all">{{item.empId}}</td>
                                <td class="px-3 py-4 text-sm text-gray-900 dark:text-gray-300">{{item.firstNameEnglish}}
                                </td>
                                <td class="px-3 py-4 text-sm text-gray-900 dark:text-gray-300">{{item.lastNameEnglish}}
                                </td>
                                <td class="px-3 py-4 text-sm text-gray-900 dark:text-gray-300"
                                    *ngIf="logingRole ==='Distribution Centre Head'">{{ item.centerName ?
                                    item.centerName :
                                    '—' }}</td>
                                <td class="px-3 py-4 text-sm text-gray-900 dark:text-gray-300">{{item.jobRole}}</td>
                                <td class="px-3 py-4 text-center">
                                    <div class="flex justify-center items-center" [ngClass]="{
        'cursor-pointer': logingRole === 'Distribution Centre Head',
        'cursor-default': logingRole !== 'Distribution Centre Head'
    }" (click)="logingRole === 'Distribution Centre Head' && openPopup(item)">

                                        <span *ngIf="item.status === 'Approved'"
                                            class="inline-block w-[120px] px-6 py-1 bg-[#C8E0FF] text-[#415CFF] text-sm font-medium rounded-md text-center"
                                            [ngClass]="{ 'shadow-md': logingRole === 'Distribution Centre Head' }">
                                            Approved
                                        </span>

                                        <span *ngIf="item.status === 'Not Approved'"
                                            class="inline-block w-[120px] px-3 py-1 bg-[#F8FFA6] text-[#A8A100] text-sm font-medium rounded-md text-center"
                                            [ngClass]="{ 'shadow-md': logingRole === 'Distribution Centre Head' }">
                                            Not Approved
                                        </span>

                                        <span *ngIf="item.status === 'Rejected'"
                                            class="inline-block w-[120px] px-8 py-1 bg-[#FFB9B7] text-[#D16D6A] text-sm font-medium rounded-md text-center"
                                            [ngClass]="{ 'shadow-md': logingRole === 'Distribution Centre Head' }">
                                            Rejected
                                        </span>

                                    </div>
                                </td>

                                <td class="px-3 py-4 text-sm text-gray-900 dark:text-gray-300 text-center">
                                    {{ item.phoneNumber01 ? item.phoneCode01 + item.phoneNumber01 : 'N/A' }}
                                </td>
                                <td class="px-3 py-4 text-sm text-gray-900 dark:text-gray-300 text-center">{{item.nic}}
                                </td>
                                <td class="px-3 py-4 text-sm text-gray-900 dark:text-gray-300 text-center">
                                    <button class="text-gray-400 hover:text-gray-600 px-2"
                                        (click)="navigateToProfile(item.id)">
                                        <i class="fa-regular fa-file text-lg text-gray-600"></i>
                                    </button>

                                    <button class="text-[#415CFF] hover:text-blue-500 px-2" [ngClass]="{
                                'text-gray-400 hover:text-gray-600': (logingRole ==='Distribution Centre Manager' && (item.jobRole === 'Distribution Centre Manager'))
                              }" (click)="(logingRole ==='Distribution Centre Manager' && (item.jobRole === 'Distribution Centre Manager')) ? '' : navigateToEdit(item.id)">
                                        <i class="fa-solid fa-pen-to-square text-lg"></i>
                                    </button>
                                    <button class="text-[#FF415C] px-2" [ngClass]="{
                                'text-gray-400 hover:text-gray-600': (logingRole ==='Distribution Centre Manager' && (item.jobRole === 'Distribution Centre Manager'))
                              }" (click)="(logingRole ==='Distribution Centre Manager' && item.jobRole === 'Distribution Centre Manager') ? '' : deleteCollectionOfficer(item.id, item.jobRole)">
                                        <i class="fa-solid fa-trash text-lg"></i>
                                    </button>

                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
                <div *ngIf="hasData" class="flex justify-end items-center my-5 pt-3 dark:bg-[#1D1D1F] text-right">
                    <pagination-controls (pageChange)="onPageChange($event)" [responsive]="true"
                        [previousLabel]="'Previous'" [nextLabel]="'Next'" [screenReaderPaginationLabel]="'Pagination'"
                        [screenReaderPageLabel]="'page'" [screenReaderCurrentLabel]="'Youre on page'">
                    </pagination-controls>
                </div>
            </div>



        </div>



    </div>
</div>
